import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import { Grid, Label, LabelGroup } from "semantic-ui-react";
import { default1PSeller } from "../../../../libs/consts";

const PermissionDetailBody = ({ permission }) => {
  const intl = useIntl();
  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={4}>
          <p>
            <strong>
              {intl.formatMessage({
                id: "LABEL_AGENCY",
                defaultMessage: "Agency",
              })}
            </strong>
          </p>
        </Grid.Column>
        <Grid.Column width={12}>
          <p>{permission.agency_name ?? `Agency-${permission.agency_id}`}</p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4}>
          <p>
            <strong>
              {intl.formatMessage({
                id: "LABEL_ADVERTISERS",
                defaultMessage: "Advertisers",
              })}
            </strong>
          </p>
        </Grid.Column>
        <Grid.Column width={12}>
          <div>
            <LabelGroup>
              {permission.advertisers.length === 0 && (
                <Label>
                  {intl.formatMessage({
                    id: "LABEL_ALL_ADVERTISERS",
                    defaultMessage: "All Advertisers",
                  })}
                </Label>
              )}
              {permission.advertisers.map((advertiser) => (
                <Label key={advertiser.name}>{advertiser.name}</Label>
              ))}
            </LabelGroup>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4}>
          <p>
            <strong>
              {intl.formatMessage({
                id: "LABEL_SELLERS",
                defaultMessage: "Sellers",
              })}
            </strong>
          </p>
        </Grid.Column>
        <Grid.Column width={12}>
          <div>
            <LabelGroup>
              {permission.seller_ids.length === 0 && (
                <Label>
                  {intl.formatMessage({
                    id: "LABEL_ALL_SELLERS",
                    defaultMessage: "All Sellers",
                  })}
                </Label>
              )}
              {permission.seller_ids.map((sellerId) => (
                <Label key={sellerId}>{sellerId === default1PSeller.value ? "1P" : sellerId}</Label>
              ))}
            </LabelGroup>
          </div>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={4}>
          <p>
            <strong>
              {intl.formatMessage({
                id: "LABEL_BRANDS",
                defaultMessage: "Brands",
              })}
            </strong>
          </p>
        </Grid.Column>
        <Grid.Column width={12}>
          <div>
            <LabelGroup>
              {permission.brands.length === 0 && (
                <Label>
                  {intl.formatMessage({
                    id: "LABEL_ALL_BRANDS",
                    defaultMessage: "All Brands",
                  })}
                </Label>
              )}
              {permission.brands.map((brand) => (
                <Label key={brand}>{brand}</Label>
              ))}
            </LabelGroup>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default PermissionDetailBody;

PermissionDetailBody.propTypes = {
  permission: PropTypes.object.isRequired,
};
